
(function ($) {

    'use strict';

    $(document).on('click', '.segmented-control .control-item', function (e) {
        e.preventDefault();

        var container = $(e.target).data('target');
        if (!container) return;


        $('.segmented-control .control-item').removeClass('active');
        $('.control-content').removeClass('active');

        $(e.target).addClass('active');
        $(container).addClass('active');

        return false;
    });

    $('.segmented-control .control-item').addClass('noeffect');
    
})(window.jQuery);